Bacon = require 'baconjs'
R = require 'ramda'
client = require 'api/auth'
api = require 'api/channel-search'

terms = new Bacon.Bus

termsStream = terms
  .debounce(200)

responseToJSON = (response) ->
  Bacon
  .fromPromise response.json()
  .mapError R.always {}

processJSONWithStatus = (response) ->
  if response.status >= 200 and response.status < 300
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Next data
  else
    responseToJSON(response)
      .flatMap (data) ->
        new Bacon.Error data

searchChannels = termsStream
  .flatMap api.search
  .map ({data}) ->
    data

loading = termsStream.awaiting(searchChannels)

module.exports =
  search: (term) -> terms.push term
  results: searchChannels
  loading: loading
